import { tv } from 'tailwind-variants';

export const Card = tv({
  base: 'flex flex-col w-full group rounded-md gap-xl transition ease-in-out delay-100 shadow-level-1 p-5 bg-color-lightest items-center justify-evenly cursor-pointer hover:text-color-white',
  variants: {
    type: {
      modules: '',
    },
    color: {
      interdisciplinar: 'hover:bg-disciplina-interdisciplinar',
      redacao: 'hover:bg-disciplina-redacao',
      literatura: 'hover:bg-disciplina-literatura',
      espanhol: 'hover:bg-disciplina-espanhol',
      ingles: 'hover:bg-disciplina-ingles',
      portugues: 'hover:bg-disciplina-portugues',
      gramatica: 'hover:bg-disciplina-portugues',
      sociologia: 'hover:bg-disciplina-sociologia',
      filosofia: 'hover:bg-disciplina-filosofia',
      geografia: 'hover:bg-disciplina-geografia',
      historia: 'hover:bg-disciplina-historia',
      matematica: 'hover:bg-disciplina-matematica',
      fisica: 'hover:bg-disciplina-fisica',
      quimica: 'hover:bg-disciplina-quimica',
      biologia: 'hover:bg-disciplina-biologia',
      atualidades: 'hover:bg-disciplina-atualidades',
      'bioquimica-superior': 'hover:bg-disciplina-bioquimica-superior',
      'anatomia-superior': 'hover:bg-disciplina-anatomia-humana-superior',
      'histologia-humana-superior':
        'hover:bg-disciplina-histologia-humana-superior',
      'fisiologia-superior': 'hover:bg-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'hover:bg-disciplina-genetica-superior',
      'embriologia-superior': 'hover:bg-disciplina-embriologia-superior',
      'imunologia-superior': 'hover:bg-disciplina-imunologia-superior',
      'microbiologia-superior': 'hover:bg-disciplina-microbiologia-superior',
      'parasitologia-superior': 'hover:bg-disciplina-parasitologia-superior',
      'patologia-superior': 'hover:bg-disciplina-patologia-superior',
      'farmacologia-superior': 'hover:bg-disciplina-farmacologia-superior',
    },
  },
});

export const IconVariant = tv({
  base: 'stroke-0 group-hover:fill-card-color-default dark:fill-card-color-default transition ease-in-out delay-100',
  variants: {
    type: {
      modules: 'h-16 w-16',
    },
    color: {
      interdisciplinar: 'fill-disciplina-interdisciplinar',
      redacao: 'fill-disciplina-redacao',
      literatura: 'fill-disciplina-literatura',
      espanhol: 'fill-disciplina-espanhol',
      ingles: 'fill-disciplina-ingles',
      portugues: 'fill-disciplina-portugues',
      gramatica: 'fill-disciplina-portugues',
      sociologia: 'fill-disciplina-sociologia',
      filosofia: 'fill-disciplina-filosofia',
      geografia: 'fill-disciplina-geografia',
      historia: 'fill-disciplina-historia',
      matematica: 'fill-disciplina-matematica',
      fisica: 'fill-disciplina-fisica',
      quimica: 'fill-disciplina-quimica',
      biologia: 'fill-disciplina-biologia',
      atualidades: 'fill-disciplina-atualidades',
      'bioquimica-superior': 'fill-disciplina-bioquimica-superior',
      'anatomia-superior': 'fill-disciplina-anatomia-humana-superior',
      'histologia-humana-superior':
        'fill-disciplina-histologia-humana-superior',
      'fisiologia-superior': 'fill-disciplina-fisiologia-humana-superior',
      'genetica-superior': 'fill-disciplina-genetica-superior',
      'embriologia-superior': 'fill-disciplina-embriologia-superior',
      'imunologia-superior': 'fill-disciplina-imunologia-superior',
      'microbiologia-superior': 'fill-disciplina-microbiologia-superior',
      'parasitologia-superior': 'fill-disciplina-parasitologia-superior',
      'patologia-superior': 'fill-disciplina-patologia-superior',
      'farmacologia-superior': 'fill-disciplina-farmacologia-superior',
    },
  },
});


export const TextVariant = tv({
  base: '',
  variants: {
    type: {
      title: 'md:line-clamp-5 text-center',
      paragraph: '',
    },
    hover: {
      white:
        'group-hover:text-card-color-default transition ease-in-out delay-100',
    },
  },
});
